<template>
    <div class="t-container">
        <template v-if="module == 'view_edit_details'">
            <span v-if="type == 'contractassetdetail'">{{ sender }} is currently {{flag}}ing this Contract Asset.</span>
            <span v-else>{{ sender }} is currently {{flag}}ing this {{ ucString(type) }}.</span>
        </template>
        <template v-else-if="module == 'customer_invoice'">
            <span>{{ ucString(type) }} process has been completed<br>
            <b><a style="color:black" @click.stop="openPage" >Click Here</a></b> to view.</span>
        </template>
        <template v-else-if="module == 'export'">
            <span>{{ ucString(type) }} process has been completed<br>
            <b><a style="color:black" @click.stop="openPage" >Click Here</a></b> to download.</span>
        </template>
        <template v-else>
            <template v-if="status == 'sent'">
                <span v-if="type == 'security_deposit'"><b>{{ sender }}</b> has requested refund for security deposit</span>
                <span v-else-if="type == 'credit_override'"><b>{{ sender }}</b> has requested for the customer credit override</span>
                <span v-else-if="type == 'rate_approval'"><b>{{ sender }}</b> has requested for the long term rate approval</span>
                <span v-else-if="type == 'depreciation'"><b>{{ sender }}</b> has initiated the depreciation</span><br>
            </template>
            <template v-else>
                <span v-if="type == 'security_deposit'"><b>{{ sender }}</b> has {{ status }} your security deposit refund request for the {{ ucString(module) }}</span>
                <span v-else-if="type == 'credit_override'"><b>{{ sender }}</b> has {{ status }} your credit override request for the {{ ucString(module) }}</span>
                <span v-else-if="type == 'rate_approval'"><b>{{ sender }}</b> has {{ status }} your long term rate approval request for the {{ ucString(module) }}</span><br>
            </template>
            <b><u><button type="button" style="color:black" @click.stop="openPage" >Click Here</button></u></b> to view details.
        </template>
        <button aria-label="close" class="Vue-Toastification__close-button" @click.stop="close"> × </button>
    </div>
</template>
<script>
export default {
  props: ["sender","customer_id","module","status","type","flag"],
  methods: {
        openPage: function() {
            this.$emit("click");
            this.$emit('close-toast');
        },
        close: function() {
            this.$emit("handleClose");
            this.$emit('close-toast');
        },
        //make sentence first letter capital
        ucString(data) {
            var self = this;
            var value = data.replace(/_/g, " ");
            var upp = value.toLowerCase().replace(/\b[a-z]/g, function(letter) {
                return letter.toUpperCase();
            });
            return upp;
        }

  }
};
</script>
<style scoped>
.Vue-Toastification__close-button {
    position: absolute;
    top: 1px;
    right: 9px;
    font-size: 19px;
    opacity: 1;
}
.t-container a {
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/customer/CreditOverrideNotification.vue